import React, { useEffect, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { useNavigate } from "react-router-dom";
import { FaTrashAlt, FaEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";

export default function Sale() {
  const [imeiNotFound, setImeiNotFound] = useState(false);
  //............set  todays date

  const today = new Date().toISOString().split("T")[0];
  //............Customer Details
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [date, setDate] = useState(today);
  const [customerName, setCustomerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");

  //............Buy Back Details

  const [buyBackIemi, setBuyBacIemi] = useState("");
  const [buyBackModel, setBuyBackModel] = useState("");
  let [buyBackPrice, setBuyBackPrice] = useState("");
  const [buyBackSalePrice, setBuyBackSalePrice] = useState(""); // Sale Price field
  let [buyBackModel1, setBuyBackModel1] = useState("");
  const [buyBackColor, setBuyBackColor] = useState("");
  //..............Brand Details


  const [modelName1, setModelName1] = useState("");
  const [imei, setImei] = useState("");
  const [mrp, setMrp] = useState("");
  const [brandDiscount, setBrandDiscount] = useState("");
  const [price, setPrice] = useState("");
  const [color, setColor] = useState("");

  const [accessories, setAccessories] = useState("Charger, Bill Box");

  //................Payment Details
  const [subTotal, setSubTotal] = useState(0);
  const [discount, setDiscount] = useState("");
  let [grantTotal, setGrantTotal] = useState(0);
  const [payableAmount, setPayableAmount] = useState("");
  const [payableAmount1, setPayableAmount1] = useState("");
  const [paymentMode, setPaymentMode] = useState("Cash Deposit");
  const [paymentMode1, setPaymentMode1] = useState("");
  let [balance, setBalance] = useState(0);

  const [tableData, setTableData] = useState([]);
  const [buyBackItems, setBuyBackItems] = useState([]); // Store buy back items in array
  const [buyBackTotal, setBuyBackTotal] = useState(0); // Track total Buy Back price
  const [editIndex, setEditIndex] = useState(null); // Track which Brand Details item is being edited
  const [editBuyBackIndex, setEditBuyBackIndex] = useState(null); // Track which Buy Back item is being edited

  //  .............brand list hide after refreshing
  const [shouldFetchData, setShouldFetchData] = useState(false);





  const [isDataChanged, setIsDataChanged] = useState(false);

  // Validation states
  const [errors, setErrors] = useState({
    invoiceNumber: "",
    date: "",
    customerName: "",
    mobileNumber: "",
    // Brand Details
    imei: "",
    modelName1: "",
    color: "",
    mrp: "",
    brandDiscount: "",
    price: "",
    // Buy Back Details
    buyBackIemi: "",
    buyBackModel1: "",
    buyBackColor: "",
    buyBackPrice: "",
    buyBackSalePrice: "",
    // Payment Details
    payableAmount: "",
    payableAmount1: "",
    paymentMode1: "",
    tableData: "",
  });
  const [touched, setTouched] = useState({
    invoiceNumber: false,
    date: false,
    customerName: false,
    mobileNumber: false,
    imei: false,
    modelName1: false,
    color: false,
    mrp: false,
    brandDiscount: false,
    price: false,
    buyBackIemi: false,
    buyBackModel1: false,
    buyBackColor: false,
    buyBackPrice: false,
    buyBackSalePrice: false,
    payableAmount: false,
    payableAmount1: false,
    paymentMode1: false,
  });
  const [submitAttempted, setSubmitAttempted] = useState(false);

  // ..............................< Unsaved Navigation>...............................
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDataChanged) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataChanged]);

  // Callback function to handle navigation from the header
  const handleHeaderNavigation = () => {
    if (isDataChanged && !window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
      // If there are unsaved changes and the user clicks cancel, prevent navigation
      return false;
    }
    return true; // Allow navigation
  };


  // ...........................<Cancle Model>.......................

  const cancelModel = () => {
    if (isDataChanged) {
      const confirmCancel = window.confirm('You have unsaved changes. Are you sure you want to cancel?');
      if (!confirmCancel) {
        return;
      }
    }

    // Clear all Customer Details
    setInvoiceNumber('');
    setDate(today);
    setCustomerName('');
    setMobileNumber('');
    setAddress('');

    // Clear all Brand Details
    setModelName1('');
    setImei('');
    setMrp('');
    setBrandDiscount('');
    setPrice('');
    setColor('');
    setAccessories('Charger, Bill Box');
    setTableData([]); // Clear Brand Details array

    // Clear all Buy Back Details
    setBuyBackModel1('');
    setBuyBacIemi('');
    setBuyBackColor('');
    setBuyBackPrice('');
    setBuyBackSalePrice('');
    setBuyBackItems([]); // Clear Buy Back array
    setBuyBackTotal(0);

    // Clear Payment Details
    setSubTotal(0);
    setGrantTotal(0);
    setPayableAmount('');
    setPayableAmount1('');
    setPaymentMode('Cash Deposit');
    setPaymentMode1('');
    setBalance(0);

    // Clear Edit States
    setEditIndex(null);
    setEditBuyBackIndex(null);

    // Clear IMEI Not Found flag
    setImeiNotFound(false);

    // Reset validation states
    setErrors({
      invoiceNumber: "",
      date: "",
      customerName: "",
      mobileNumber: "",
      imei: "",
      modelName1: "",
      color: "",
      mrp: "",
      brandDiscount: "",
      price: "",
      buyBackIemi: "",
      buyBackModel1: "",
      buyBackColor: "",
      buyBackPrice: "",
      payableAmount: "",
      payableAmount1: "",
      paymentMode1: "",
      tableData: "",
    });
    setTouched({
      invoiceNumber: false,
      date: false,
      customerName: false,
      mobileNumber: false,
      imei: false,
      modelName1: false,
      color: false,
      mrp: false,
      brandDiscount: false,
      price: false,
      buyBackIemi: false,
      buyBackModel1: false,
      buyBackColor: false,
      buyBackPrice: false,
      payableAmount: false,
      payableAmount1: false,
      paymentMode1: false,
    });
    setSubmitAttempted(false);
    setIsDataChanged(false);

    toast.success("Form cleared successfully");
  };

  const handleInputChange = (e) => {
    const v = capitalizeWords(e.target.value);
    setCustomerName(v);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.customerName || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        customerName: validateCustomerName(v),
      }));
    }
  };

  const handleCustomerNameBlur = () => {
    setTouched((prev) => ({ ...prev, customerName: true }));
    setErrors((prev) => ({
      ...prev,
      customerName: validateCustomerName(customerName),
    }));
  };

  const handleInvoiceNumberChange = (e) => {
    const value = e.target.value;
    setInvoiceNumber(value);
    setIsDataChanged(true);
    
    if (touched.invoiceNumber || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: validateInvoiceNumber(value),
      }));
    }
  };

  const handleInvoiceNumberBlur = () => {
    setTouched((prev) => ({ ...prev, invoiceNumber: true }));
    setErrors((prev) => ({
      ...prev,
      invoiceNumber: validateInvoiceNumber(invoiceNumber),
    }));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setDate(value);
    setIsDataChanged(true);
    
    if (touched.date || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        date: validateDate(value),
      }));
    }
  };

  const handleDateBlur = () => {
    setTouched((prev) => ({ ...prev, date: true }));
    setErrors((prev) => ({
      ...prev,
      date: validateDate(date),
    }));
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setMobileNumber(value);
    setIsDataChanged(true);
    
    if (touched.mobileNumber || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        mobileNumber: validateMobileNumber(value),
      }));
    }
  };

  const handleMobileNumberBlur = () => {
    setTouched((prev) => ({ ...prev, mobileNumber: true }));
    setErrors((prev) => ({
      ...prev,
      mobileNumber: validateMobileNumber(mobileNumber),
    }));
  };

  // ................[ Add brand details {table}  ]......................

  const apiUrl = Config.apiUrl;

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  // Validation functions
  const validateInvoiceNumber = (value) => {
    if (!value || value.trim() === "") {
      return "Invoice number is required";
    }
    if (!/^\d+$/.test(value.trim())) {
      return "Invoice number must contain only digits";
    }
    return "";
  };

  const validateDate = (value) => {
    if (!value || value.trim() === "") {
      return "Date is required";
    }
    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    if (selectedDate > todayDate) {
      return "Date cannot be in the future";
    }
    return "";
  };

  const validateCustomerName = (value) => {
    if (!value || value.trim() === "") {
      return "Customer name is required";
    }
    if (value.trim().length < 2) {
      return "Customer name must be at least 2 characters";
    }
    if (value.trim().length > 100) {
      return "Customer name must not exceed 100 characters";
    }
    return "";
  };

  const validateMobileNumber = (value) => {
    if (!value || value.trim() === "") {
      return "Mobile number is required";
    }
    if (!/^\d+$/.test(value)) {
      return "Mobile number must contain only digits";
    }
    if (value.length !== 10) {
      return "Mobile number must be exactly 10 digits";
    }
    return "";
  };

  // Brand Details validation
  const validateBrandDetails = () => {
    const errors = {};
    if (!imei || imei.trim() === "") {
      errors.imei = "IMEI is required";
    }
    if (!modelName1 || modelName1.trim() === "") {
      errors.modelName1 = "Model name is required";
    }
    if (!color || color.trim() === "") {
      errors.color = "Color is required";
    }
    if (!mrp || mrp.trim() === "") {
      errors.mrp = "MRP is required";
    } else {
      const numMrp = parseFloat(mrp.replace(/[,\s]/g, ''));
      if (isNaN(numMrp) || numMrp <= 0) {
        errors.mrp = "MRP must be a valid number greater than 0";
      }
    }
    if (brandDiscount && brandDiscount.trim() !== "") {
      const numDiscount = parseFloat(brandDiscount.replace(/[,\s]/g, ''));
      if (isNaN(numDiscount) || numDiscount < 0) {
        errors.brandDiscount = "Discount must be a valid number (0 or greater)";
      }
    }
    if (!price || price.trim() === "") {
      errors.price = "Price is required";
    } else {
      const numPrice = parseFloat(price.replace(/[,\s]/g, ''));
      if (isNaN(numPrice) || numPrice <= 0) {
        errors.price = "Price must be a valid number greater than 0";
      }
    }
    return errors;
  };

  // Buy Back Details validation
  const validateBuyBackDetails = () => {
    const errors = {};
    if (!buyBackModel1 || buyBackModel1.trim() === "") {
      errors.buyBackModel1 = "Model name is required";
    }
    if (!buyBackColor || buyBackColor.trim() === "") {
      errors.buyBackColor = "Color is required";
    }
    if (!buyBackIemi || buyBackIemi.trim() === "") {
      errors.buyBackIemi = "IMEI is required";
    }
    if (!buyBackPrice || buyBackPrice.trim() === "") {
      errors.buyBackPrice = "Price is required";
    } else {
      const numPrice = parseFloat(buyBackPrice);
      if (isNaN(numPrice) || numPrice <= 0) {
        errors.buyBackPrice = "Price must be a valid number greater than 0";
      }
    }
    return errors;
  };

  // Payment validation
  const validatePayment = () => {
    const errors = {};
    
    // Skip payment validation if Grant Total is negative (fields are disabled)
    if (grantTotal < 0) {
      return errors;
    }
    
    // Cash Amount is optional, but if entered, should be valid number
    if (payableAmount && payableAmount.trim() !== "") {
      const cleanCashAmount = payableAmount.replace(/[,\s]/g, '');
      const numCashAmount = parseFloat(cleanCashAmount);
      if (isNaN(numCashAmount) || numCashAmount < 0) {
        errors.payableAmount = "Cash amount must be a valid number (0 or greater)";
      }
    }

    // Online Amount is optional, but if entered:
    // 1. Should be valid number
    // 2. Payment Mode 2 is required
    if (payableAmount1 && payableAmount1.trim() !== "") {
      const cleanOnlineAmount = payableAmount1.replace(/[,\s]/g, '');
      const numOnlineAmount = parseFloat(cleanOnlineAmount);
      if (isNaN(numOnlineAmount) || numOnlineAmount < 0) {
        errors.payableAmount1 = "Online amount must be a valid number (0 or greater)";
      }
      
      // Payment Mode 2 is required if Online Amount is entered
      if (!paymentMode1 || paymentMode1.trim() === "") {
        errors.paymentMode1 = "Payment mode is required when online amount is entered";
      }
    }

    return errors;
  };

  // Final submit validation
  const validateAllForSubmit = () => {
    const newErrors = {
      invoiceNumber: validateInvoiceNumber(invoiceNumber),
      date: validateDate(date),
      customerName: validateCustomerName(customerName),
      mobileNumber: validateMobileNumber(mobileNumber),
      tableData: tableData.length === 0 ? "At least one brand item must be added" : "",
    };

    // Add payment validation (only validates if amounts are entered, not required)
    const paymentErrors = validatePayment();
    Object.assign(newErrors, paymentErrors);

    setErrors(newErrors);
    return !newErrors.invoiceNumber && !newErrors.date && !newErrors.customerName && 
           !newErrors.mobileNumber && !newErrors.tableData && 
           !newErrors.payableAmount && !newErrors.payableAmount1 && !newErrors.paymentMode1;
  };

  const addBrandDetails = async (e) => {
    e.preventDefault();

    // First check if Invoice Number is filled
    if (!invoiceNumber || invoiceNumber.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: "Invoice number is required before adding brand details",
      }));
      setTouched((prev) => ({ ...prev, invoiceNumber: true }));
      toast.warning("Please enter Invoice Number first");
      return;
    }

    // Validate invoice number format
    const invoiceError = validateInvoiceNumber(invoiceNumber);
    if (invoiceError) {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: invoiceError,
      }));
      setTouched((prev) => ({ ...prev, invoiceNumber: true }));
      return;
    }

    // Validate brand details
    const brandErrors = validateBrandDetails();
    if (Object.keys(brandErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...brandErrors }));
      // Mark fields as touched
      setTouched((prev) => ({
        ...prev,
        imei: true,
        modelName1: true,
        color: true,
        mrp: true,
        brandDiscount: true,
        price: true,
      }));
      return;
    }

    // Check for duplicate IMEI (skip if editing same item)
    if (editIndex === null) {
      const duplicateInBrandDetails = tableData.some((item, idx) => 
        idx !== editIndex && item.imei && item.imei.toString().trim().toUpperCase() === imei.toString().trim().toUpperCase()
      );

      const duplicateInBuyBack = buyBackItems.some((item) => 
        item.imei && item.imei.toString().trim().toUpperCase() === imei.toString().trim().toUpperCase()
      );

      if (duplicateInBrandDetails) {
        setErrors((prev) => ({
          ...prev,
          imei: "This IMEI already exists in Brand Details list",
        }));
        setTouched((prev) => ({ ...prev, imei: true }));
        toast.error("Duplicate IMEI! This IMEI already exists in Brand Details list");
        return;
      }

      if (duplicateInBuyBack) {
        setErrors((prev) => ({
          ...prev,
          imei: "This IMEI already exists in Buy Back list",
        }));
        setTouched((prev) => ({ ...prev, imei: true }));
        toast.error("Duplicate IMEI! This IMEI already exists in Buy Back list");
        return;
      }
    }

    // Clear errors if validation passes
    setErrors((prev) => ({
      ...prev,
      imei: "",
      modelName1: "",
      color: "",
      mrp: "",
      brandDiscount: "",
      price: "",
    }));

    let item = {
      invoice_no: invoiceNumber,
      model_name: modelName1,
      imei: imei,
      mrp: mrp,
      discount: brandDiscount || "0",
      price: price,
      color: color,
      accessories: accessories,
    };

    // Update existing item or add new item
    if (editIndex !== null) {
      // Update existing item in array
      setTableData((prevTableData) => {
        const newArray = [...prevTableData];
        newArray[editIndex] = item;
        console.log("Brand Details Array Updated:", newArray);
        return newArray;
      });
      toast.success("Item updated successfully");
      setEditIndex(null);
    } else {
      // Add new item to state array (no API call - will save on final submit)
      setTableData((prevTableData) => {
        const newArray = [...prevTableData, item];
        console.log("Brand Details Array:", newArray);
        return newArray;
      });
      toast.success("Item added to list");
    }

    // Clear the input fields
    setModelName1("");
    setImei("");
    setMrp("");
    setBrandDiscount("");
    setPrice("");
    setColor("");
    setAccessories("Charger, Bill Box");

    // Sub Total and Grant Total will be calculated automatically by useEffect based on tableData
  };

  // Removed: No longer fetching sales_items on mount since we store in state until submit

  // Edit Brand Details item
  const handleEdit = (index) => {
    const item = tableData[index];
    if (item) {
      setEditIndex(index);
      setModelName1(item.model_name || "");
      setImei(item.imei || "");
      setMrp(item.mrp || "");
      setBrandDiscount(item.discount || "0");
      setPrice(item.price || "");
      setColor(item.color || "");
      setAccessories(item.accessories || "Charger, Bill Box");
      toast.info("Editing item. Make changes and click Add to update.");
    }
  };

  // Cancel edit for Brand Details
  const handleCancelEdit = () => {
    setEditIndex(null);
    setModelName1("");
    setImei("");
    setMrp("");
    setBrandDiscount("");
    setPrice("");
    setColor("");
    setAccessories("Charger, Bill Box");
    setErrors((prev) => ({
      ...prev,
      imei: "",
      modelName1: "",
      color: "",
      mrp: "",
      brandDiscount: "",
      price: "",
    }));
  };

  // Delete Record from state (no API call since items not saved yet)
  const handleDelete = (id, index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this item from the list?"
    );

    if (confirmDelete) {
      // Remove from state array (items are not saved to DB until final submit)
      setTableData((preData) => preData.filter((_, i) => i !== index));
      toast.success("Item removed from list");
    }
  };

  // Edit Buy Back item
  const handleEditBuyBack = (index) => {
    const item = buyBackItems[index];
    if (item) {
      setEditBuyBackIndex(index);
      setBuyBackModel1(item.model_name || "");
      setBuyBacIemi(item.imei || "");
      setBuyBackColor(item.color || "");
      setBuyBackPrice(item.price || "");
      setBuyBackSalePrice(item.sales_price || "");
      toast.info("Editing buy back item. Make changes and click Buy Back to update.");
    }
  };

  // Cancel edit for Buy Back
  const handleCancelEditBuyBack = () => {
    setEditBuyBackIndex(null);
    setBuyBackModel1("");
    setBuyBacIemi("");
    setBuyBackColor("");
    setBuyBackPrice("");
    setBuyBackSalePrice("");
    setErrors((prev) => ({
      ...prev,
      buyBackIemi: "",
      buyBackModel1: "",
      buyBackColor: "",
      buyBackPrice: "",
      buyBackSalePrice: "",
    }));
  };

  // Delete Buy Back item from state
  const handleDeleteBuyBack = (index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this buy back item from the list?"
    );

    if (confirmDelete) {
      // Get the price of item being deleted to update total
      const deletedItem = buyBackItems[index];
      const deletedPrice = parseFloat(deletedItem?.price?.toString().replace(/[,\s]/g, '')) || 0;
      
      // Remove from state array
      setBuyBackItems((preData) => preData.filter((_, i) => i !== index));
      
      // Update buy back total
      setBuyBackTotal((prevTotal) => Math.max(0, prevTotal - deletedPrice));
      
      toast.success("Buy back item removed from list");
    }
  };

  // ..........................[ Calculate Sub Total (MRP sum) and Grant Total (Price sum) from tableData ].............................
  useEffect(() => {
    // Calculate Sub Total = MRP sum (only from Brand Details)
    let mrpTotal = 0;
    if (tableData && tableData.length > 0) {
      mrpTotal = tableData.reduce((sum, item) => {
        const mrpValue = parseFloat(item.mrp?.toString().replace(/[,\s]/g, '')) || 0;
        return sum + mrpValue;
      }, 0);
    }
    setSubTotal(mrpTotal);

    // Calculate Grant Total = Price sum (positive from Brand Details) - Buy Back total (negative)
    // Allow both positive and negative values
    let priceTotal = 0;
    if (tableData && tableData.length > 0) {
      priceTotal = tableData.reduce((sum, item) => {
        const priceValue = parseFloat(item.price?.toString().replace(/[,\s]/g, '')) || 0;
        return sum + priceValue;
      }, 0);
    }
    
    // Grand Total = Positive amounts (Brand Details) - Negative amounts (Buy Back)
    // This can be positive, negative, or zero
    const finalGrantTotal = priceTotal - buyBackTotal;
    setGrantTotal(finalGrantTotal);
  }, [tableData, buyBackTotal]);

  // Clear payment fields when Grant Total becomes negative
  useEffect(() => {
    if (grantTotal < 0) {
      setPayableAmount("");
      setPayableAmount1("");
      setPaymentMode1("");
      // Clear related errors
      setErrors((prev) => ({
        ...prev,
        payableAmount: "",
        payableAmount1: "",
        paymentMode1: "",
      }));
    }
  }, [grantTotal]);

  // .......................[ Add All Sales Details ]------------------------

  const addAllDetails = async (e) => {
    e.preventDefault();

    // Mark submit as attempted
    setSubmitAttempted(true);

    // Mark all customer fields as touched
    setTouched((prev) => ({
      ...prev,
      invoiceNumber: true,
      date: true,
      customerName: true,
      mobileNumber: true,
      payableAmount: true,
      payableAmount1: true,
      paymentMode1: true,
    }));

    // Validate all fields for final submit
    if (!validateAllForSubmit()) {
      return;
    }

    // Step 1: Save Sales Details first
    let salesDetailsItem = {
      invoice_no: invoiceNumber.trim(),
      date: date,
      customer_name: customerName.trim(),
      mobile_no: mobileNumber.trim(),
      address: address.trim(),
      sub_total: subTotal,
      grand_total: grantTotal,
      payable_amount: payableAmount || 0,
      payment_mode: paymentMode,
      payable_amount_2: payableAmount1 || 0,
      payment_mode_2: paymentMode1 || ""
    };

    // Validate arrays before submit
    if (!tableData || tableData.length === 0) {
      toast.error("Please add at least one brand item before submitting");
      setErrors((prev) => ({ ...prev, tableData: "At least one brand item is required" }));
      return;
    }

    console.log("Submitting Sales Data:");
    console.log("Sales Details:", salesDetailsItem);
    console.log("Brand Details Array (tableData):", tableData);
    console.log("Buy Back Items Array (buyBackItems):", buyBackItems);

    try {
      // Step 1: Save Sales Details
      let salesDetailsResult = await fetch(`${apiUrl}/sales_details`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(salesDetailsItem),
      });

      // Parse response to get message
      let salesDetailsResponseData = null;
      try {
        salesDetailsResponseData = await salesDetailsResult.json();
      } catch (e) {
        // Response might not be JSON
        console.log("Response is not JSON");
      }

      if (!salesDetailsResult.ok) {
        // Try to get error message from response
        let errorMessage = "Failed to save sales details";
        if (salesDetailsResponseData) {
          errorMessage = salesDetailsResponseData.message || salesDetailsResponseData.error || salesDetailsResponseData.msg || errorMessage;
        } else {
          // If response is not JSON, use status text
          errorMessage = salesDetailsResult.statusText || errorMessage;
        }
        toast.error(errorMessage);
        return;
      }

      // If successful, check if there's a success message from API
      if (salesDetailsResponseData && salesDetailsResponseData.message) {
        console.log("API Success Message:", salesDetailsResponseData.message);
      }

      // Step 2: Save all Sales Items (Brand Details) from tableData array
      if (tableData && tableData.length > 0) {
        console.log(`Saving ${tableData.length} Brand Details items from array...`);
        const salesItemsPromises = tableData.map(async (item, index) => {
          console.log(`Saving Brand Item ${index + 1}:`, item);
          try {
            const response = await fetch(`${apiUrl}/sales_items`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(item),
            });
            
            // Parse response to get error message if failed
            let errorMessage = null;
            if (!response.ok) {
              try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorData.error || errorData.msg || `Failed to save item ${index + 1}`;
              } catch (e) {
                errorMessage = response.statusText || `Failed to save item ${index + 1}`;
              }
            }
            
            return { success: response.ok, errorMessage, index: index + 1 };
          } catch (error) {
            return { success: false, errorMessage: error.message || `Failed to save item ${index + 1}`, index: index + 1 };
          }
        });

        const salesItemsResults = await Promise.all(salesItemsPromises);
        
        // Check each result and collect error messages
        const errors = salesItemsResults
          .filter(result => !result.success)
          .map(result => `Item ${result.index}: ${result.errorMessage}`);
        
        if (errors.length > 0) {
          // Show all error messages
          errors.forEach(error => {
            toast.error(error);
          });
          return;
        }
        console.log(`Successfully saved ${tableData.length} Brand Details items`);
      }

      // Step 3: Save all Buy Back Items from buyBackItems array
      if (buyBackItems && buyBackItems.length > 0) {
        console.log(`Saving ${buyBackItems.length} Buy Back items from array...`);
        const buyBackPromises = buyBackItems.map(async (item, index) => {
          console.log(`Saving Buy Back Item ${index + 1}:`, item);
          try {
            const response = await fetch(`${apiUrl}/returnBrand`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(item),
            });
            
            // Parse response to get error message if failed
            let errorMessage = null;
            if (!response.ok) {
              try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorData.error || errorData.msg || `Failed to save buy back item ${index + 1}`;
              } catch (e) {
                errorMessage = response.statusText || `Failed to save buy back item ${index + 1}`;
              }
            }
            
            return { success: response.ok, errorMessage, index: index + 1 };
          } catch (error) {
            return { success: false, errorMessage: error.message || `Failed to save buy back item ${index + 1}`, index: index + 1 };
          }
        });

        const buyBackResults = await Promise.all(buyBackPromises);
        
        // Check each result and collect error messages
        const buyBackErrors = buyBackResults
          .filter(result => !result.success)
          .map(result => `Buy Back Item ${result.index}: ${result.errorMessage}`);
        
        if (buyBackErrors.length > 0) {
          // Show all error messages
          buyBackErrors.forEach(error => {
            toast.error(error);
          });
          return;
        }
        console.log(`Successfully saved ${buyBackItems.length} Buy Back items`);
      }

      // All data saved successfully
      toast.success("Sales completed successfully");
      
      // Clear all state
      setTableData([]);
      setBuyBackItems([]);
      setBuyBackTotal(0);
      handleView(invoiceNumber, e);

      setInvoiceNumber("");
      setDate(today);
      setCustomerName("");
      setSubTotal(0);

      setPayableAmount("");
      setPaymentMode("Cash Deposit");
      setMobileNumber("");
      setAddress("");
      setPayableAmount1("");
      setPaymentMode1("");

      // Reset validation states
      setErrors({
        invoiceNumber: "",
        date: "",
        customerName: "",
        mobileNumber: "",
        imei: "",
        modelName1: "",
        color: "",
        mrp: "",
        brandDiscount: "",
        price: "",
        buyBackIemi: "",
        buyBackModel1: "",
        buyBackColor: "",
        buyBackPrice: "",
        payableAmount: "",
        payableAmount1: "",
        paymentMode1: "",
        tableData: "",
      });
      setTouched({
        invoiceNumber: false,
        date: false,
        customerName: false,
        mobileNumber: false,
        imei: false,
        modelName1: false,
        color: false,
        mrp: false,
        brandDiscount: false,
        price: false,
        buyBackIemi: false,
        buyBackModel1: false,
        buyBackColor: false,
        buyBackPrice: false,
        payableAmount: false,
        payableAmount1: false,
        paymentMode1: false,
      });
      setSubmitAttempted(false);
      setIsDataChanged(false);
      setGrantTotal(0);
      
      // Reload the page after successful submission
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error saving sales:", error);
      // Show the actual error message if available
      const errorMessage = error.message || "Failed to save sales. Please try again.";
      toast.error(errorMessage);
    }
  };

  // ...................[ add Buy Back Details ]------------------------

  const addBuyBackDetails = async (e) => {
    e.preventDefault();

    // First check if Invoice Number is filled
    if (!invoiceNumber || invoiceNumber.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: "Invoice number is required before adding buy back details",
      }));
      setTouched((prev) => ({ ...prev, invoiceNumber: true }));
      toast.warning("Please enter Invoice Number first");
      return;
    }

    // Validate invoice number format
    const invoiceError = validateInvoiceNumber(invoiceNumber);
    if (invoiceError) {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: invoiceError,
      }));
      setTouched((prev) => ({ ...prev, invoiceNumber: true }));
      return;
    }

    // Validate buy back details
    const buyBackErrors = validateBuyBackDetails();
    if (Object.keys(buyBackErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...buyBackErrors }));
      // Mark fields as touched
      setTouched((prev) => ({
        ...prev,
        buyBackIemi: true,
        buyBackModel1: true,
        buyBackColor: true,
        buyBackPrice: true,
      }));
      return;
    }

    // Check for duplicate IMEI (skip if editing same item)
    if (editBuyBackIndex === null) {
      const duplicateInBuyBack = buyBackItems.some((item, idx) => 
        idx !== editBuyBackIndex && item.imei && item.imei.toString().trim().toUpperCase() === buyBackIemi.toString().trim().toUpperCase()
      );

      const duplicateInBrandDetails = tableData.some((item) => 
        item.imei && item.imei.toString().trim().toUpperCase() === buyBackIemi.toString().trim().toUpperCase()
      );

      if (duplicateInBuyBack) {
        setErrors((prev) => ({
          ...prev,
          buyBackIemi: "This IMEI already exists in Buy Back list",
        }));
        setTouched((prev) => ({ ...prev, buyBackIemi: true }));
        toast.error("Duplicate IMEI! This IMEI already exists in Buy Back list");
        return;
      }

      if (duplicateInBrandDetails) {
        setErrors((prev) => ({
          ...prev,
          buyBackIemi: "This IMEI already exists in Brand Details list",
        }));
        setTouched((prev) => ({ ...prev, buyBackIemi: true }));
        toast.error("Duplicate IMEI! This IMEI already exists in Brand Details list");
        return;
      }
    }

    // Clear errors if validation passes
    setErrors((prev) => ({
      ...prev,
      buyBackIemi: "",
      buyBackModel1: "",
      buyBackColor: "",
      buyBackPrice: "",
    }));

    let item = {
      invoice_no: invoiceNumber,
      model_name: buyBackModel1,
      imei: buyBackIemi,
      color: buyBackColor,
      price: buyBackPrice,
      sales_price: buyBackSalePrice,
    };

    // Update existing item or add new item
    if (editBuyBackIndex !== null) {
      // Get old price for total calculation
      const oldItem = buyBackItems[editBuyBackIndex];
      const oldPrice = parseFloat(oldItem?.price?.toString().replace(/[,\s]/g, '')) || 0;
      const newPrice = parseFloat(buyBackPrice.replace(/[,\s]/g, '')) || 0;
      
      // Update existing item in array
      setBuyBackItems((prevItems) => {
        const newArray = [...prevItems];
        newArray[editBuyBackIndex] = item;
        console.log("Buy Back Items Array Updated:", newArray);
        return newArray;
      });
      
      // Update buy back total (subtract old, add new)
      setBuyBackTotal((prevTotal) => prevTotal - oldPrice + newPrice);
      
      toast.success("Buy Back item updated successfully");
      setEditBuyBackIndex(null);
    } else {
      // Add new item to buyBackItems state array (no API call - will save on final submit)
      setBuyBackItems((prevItems) => {
        const newArray = [...prevItems, item];
        console.log("Buy Back Items Array:", newArray);
        return newArray;
      });
      toast.success("Buy Back item added to list");

      // Calculate and update Buy Back total
      const bbprice = parseFloat(buyBackPrice.replace(/[,\s]/g, '')) || 0;
      setBuyBackTotal((prevTotal) => prevTotal + bbprice);
    }

    // Reset input fields
    setBuyBackModel1("");
    setBuyBackColor("");
    setBuyBacIemi("");
    setBuyBackPrice("");

    // Grant Total will be recalculated automatically by useEffect based on buyBackTotal
  };




  const [brand, setBrand] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_models`);
        const data = await response.json();
        setBrand(data.data.reverse());

        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const capitalizeFirst = (str) => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleModelChange = (e) => {
    const selectedModel = e.target.value;
    const capitalizedModel = capitalizeFirst(selectedModel);

    // Find the selected model in the list (case-insensitive)
    const selectedModelObject = brand.find((model) => 
      model.model_name && model.model_name.toLowerCase() === selectedModel.toLowerCase()
    );

    // Update the color based on the selected model
    if (selectedModelObject) {
      setBuyBackColor(selectedModelObject.color_name);
    } else {
      // Handle the case when the selected model is not found
      setBuyBackColor('');
    }

    // Update the model name state with capitalized first character
    setBuyBackModel1(capitalizedModel);
  };

  //................{ Fetch Invoice Number } .....................

  useEffect(() => {
    const fetchInvoiceNumber = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_invoiceno`);
        
        if (!response.ok) {
          console.error("Failed to fetch invoice number:", response.status);
          return;
        }

        const data = await response.json();
        console.log("Invoice Number API Response:", data);
        
        // Handle different response formats
        let invoiceNo = null;
        
        if (data) {
          // Format 1: { data: { invoice_no: "123" } }
          if (data.data && data.data.invoice_no) {
            invoiceNo = data.data.invoice_no;
          }
          // Format 2: { data: { invoiceNo: "123" } }
          else if (data.data && data.data.invoiceNo) {
            invoiceNo = data.data.invoiceNo;
          }
          // Format 3: { data: "123" }
          else if (data.data) {
            invoiceNo = data.data;
          }
          // Format 4: { invoice_no: "123" }
          else if (data.invoice_no) {
            invoiceNo = data.invoice_no;
          }
          // Format 5: { invoiceNo: "123" }
          else if (data.invoiceNo) {
            invoiceNo = data.invoiceNo;
          }
          // Format 6: Direct value "123" or 123
          else if (typeof data === 'string' || typeof data === 'number') {
            invoiceNo = data;
          }
        }

        // Set invoice number if found
        if (invoiceNo !== null && invoiceNo !== undefined) {
          const invoiceNumberValue = invoiceNo.toString().trim();
          if (invoiceNumberValue) {
            setInvoiceNumber(invoiceNumberValue);
            console.log("Invoice Number set to:", invoiceNumberValue);
          }
        }
      } catch (error) {
        console.error("Error fetching invoice number:", error);
        // Don't show error to user, just log it
      }
    };

    // Fetch invoice number on component mount
    fetchInvoiceNumber();
  }, []); // Run only once on component mount

  //................{ using IMEI  set Price } .....................

  const [priceList, setPriceList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_purchaseItems`);
        const data = await response.json();
        setPriceList(data.data);
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  //....................[ Update the price,model name,color when IMEI changes].................

  const updatePrice = (imei) => {
    const selectedImei = priceList.find((item) => item.imei === imei);
    if (selectedImei) {
      const newPrice = selectedImei.sale_price;
      const newModel = selectedImei.model_name;
      const newColor = selectedImei.color;
      
      // Set MRP from sale_price, and auto-calculate Price
      setMrp(newPrice || "");
      setModelName1(newModel);
      setColor(newColor);
      
      // Auto-calculate price: MRP - Discount
      const discountValue = brandDiscount ? parseFloat(brandDiscount.replace(/[,\s]/g, '')) : 0;
      const mrpValue = newPrice ? parseFloat(newPrice.toString().replace(/[,\s]/g, '')) : 0;
      if (!isNaN(mrpValue) && mrpValue > 0) {
        const calculatedPrice = mrpValue - discountValue;
        setPrice(calculatedPrice > 0 ? calculatedPrice.toString() : "");
      } else {
        setPrice(newPrice || "");
      }

      setImeiNotFound(false); // Reset the IMEI not found flag
    } else {
      setPrice("");
      setMrp("");
      setModelName1("");
      setColor('');

      setImeiNotFound(true); // Set the IMEI not found flag
    }
  };

  //............ fetch data for dropdown........

  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_models`);
        const data = await response.json();
        setModelList(data.data);
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  //........................[ navigate]

  const navigate = useNavigate();
  const handleView = async (id, event) => {
    event.stopPropagation(); // Stop event propagation
    const invoice = id;
    navigate(`/invoice_sale?invoice_no=${invoice}`);
  };
  return (
    <>
      <ToastContainer autoClose="1500" />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header onNavigate={handleHeaderNavigation} />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Sale Entry</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Customer Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {/* Invoice Number field hidden - auto-fetched from API */}
                      <div className="col-md-6 mb-3" style={{ display: "none" }}>
                        <label
                          className="form-label"
                          htmlFor="basic-default-invoice-number"
                        >
                          Invoice Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${(touched.invoiceNumber && errors.invoiceNumber) || (submitAttempted && errors.invoiceNumber) ? 'is-invalid' : touched.invoiceNumber && !errors.invoiceNumber && invoiceNumber ? 'is-valid' : ''}`}
                          id="basic-default-invoice-number"
                          placeholder="Enter Invoice Number"
                          readOnly
                          value={invoiceNumber}
                          onChange={handleInvoiceNumberChange}
                          onBlur={handleInvoiceNumberBlur}
                        />
                        {((touched.invoiceNumber && errors.invoiceNumber) || (submitAttempted && errors.invoiceNumber)) && (
                          <div className="invalid-feedback d-block">
                            {errors.invoiceNumber}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-date"
                        >
                          Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${(touched.date && errors.date) || (submitAttempted && errors.date) ? 'is-invalid' : touched.date && !errors.date && date ? 'is-valid' : ''}`}
                          id="basic-default-date"
                          placeholder="Enter date"
                          value={date}
                          onChange={handleDateChange}
                          onBlur={handleDateBlur}
                          max={today}
                        />
                        {((touched.date && errors.date) || (submitAttempted && errors.date)) && (
                          <div className="invalid-feedback d-block">
                            {errors.date}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-customer-name"
                        >
                          Customer Name <span className="text-danger">*</span>
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type="text"
                            id="basic-default-customer-name"
                            className={`form-control ${(touched.customerName && errors.customerName) || (submitAttempted && errors.customerName) ? 'is-invalid' : touched.customerName && !errors.customerName && customerName ? 'is-valid' : ''}`}
                            placeholder="Enter Customer Name"
                            aria-label="Customer Name"
                            aria-describedby="customer-name-error"
                            value={customerName}
                            onChange={handleInputChange}
                            onBlur={handleCustomerNameBlur}
                          />
                        </div>
                        {((touched.customerName && errors.customerName) || (submitAttempted && errors.customerName)) && (
                          <div className="invalid-feedback d-block" id="customer-name-error">
                            {errors.customerName}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-mobile-number"
                        >
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-mobile-number"
                          className={`form-control phone-mask ${(touched.mobileNumber && errors.mobileNumber) || (submitAttempted && errors.mobileNumber) ? 'is-invalid' : touched.mobileNumber && !errors.mobileNumber && mobileNumber ? 'is-valid' : ''}`}
                          placeholder="Enter Mobile Number"
                          maxLength={10}
                          value={mobileNumber}
                          onChange={handleMobileNumberChange}
                          onBlur={handleMobileNumberBlur}
                        />
                        {((touched.mobileNumber && errors.mobileNumber) || (submitAttempted && errors.mobileNumber)) && (
                          <div className="invalid-feedback d-block">
                            {errors.mobileNumber}
                          </div>
                        )}
                        <small className="text-muted">
                          Enter 10 digit mobile number
                        </small>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Address
                        </label>
                        <textarea
                          id="basic-default-message"
                          className="form-control"
                          placeholder="Enter Address"
                          defaultValue={""}
                          rows={1}
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Brand Details</h5>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-imei"
                        >
                          IMEI <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-imei"
                          className={`form-control phone-mask ${(touched.imei && errors.imei) ? 'is-invalid' : touched.imei && !errors.imei && imei ? 'is-valid' : ''}`}
                          placeholder="Enter IMEI"
                          value={imei}
                          style={{ textTransform: 'uppercase' }}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setImei(value);
                            updatePrice(value);
                            setIsDataChanged(true);
                            if (touched.imei) {
                              setErrors((prev) => ({
                                ...prev,
                                imei: value.trim() === "" ? "IMEI is required" : "",
                              }));
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, imei: true }));
                            setErrors((prev) => ({
                              ...prev,
                              imei: imei.trim() === "" ? "IMEI is required" : "",
                            }));
                          }}
                        />
                        {(touched.imei && errors.imei) && (
                          <div className="invalid-feedback d-block">
                            {errors.imei}
                          </div>
                        )}
                        {imeiNotFound && <span style={{ color: "red" }}>IMEI not found</span>}
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-model-name">
                              Model Name <span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-md-12 mb-3">
                                <input
                                  type="text"
                                  className={`form-control ${(touched.modelName1 && errors.modelName1) ? 'is-invalid' : touched.modelName1 && !errors.modelName1 && modelName1 ? 'is-valid' : ''}`}
                                  id="basic-default-model-name"
                                  placeholder="Enter Model Name"
                                  value={modelName1}
                                  onChange={(e) => {
                                    const value = e.target.value.toUpperCase();
                                    setModelName1(value);
                                    setIsDataChanged(true);
                                    if (touched.modelName1) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        modelName1: value.trim() === "" ? "Model name is required" : "",
                                      }));
                                    }
                                  }}
                                  onBlur={() => {
                                    setTouched((prev) => ({ ...prev, modelName1: true }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      modelName1: modelName1.trim() === "" ? "Model name is required" : "",
                                    }));
                                  }}
                                />
                                {(touched.modelName1 && errors.modelName1) && (
                                  <div className="invalid-feedback d-block">
                                    {errors.modelName1}
                                  </div>
                                )}
                              </div>
                              {/* <div className="col-md-3 mb-3">
                          <select
                          className="form-select"
                          id="basic-default-company"
                          value={modelName}
                          onChange={(e) => {
                            setModelName(e.target.value);
                            setModelName1(e.target.value); // Update both modelName and modelName1
                          }}
                        >
                          <option value="" disabled>
                            Select model name
                          </option>
                          {modelList.map((model, index) => (
                            <option key={index} value={model.model_name}>
                              {model.model_name}
                            </option>
                          ))}
                        </select>
                          </div> */}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-color">
                              Color <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${(touched.color && errors.color) ? 'is-invalid' : touched.color && !errors.color && color ? 'is-valid' : ''}`}
                              id="basic-default-color"
                              placeholder="Enter Color"
                              value={color}
                              onChange={(e) => {
                                const v = capitalizeWords(e.target.value);
                                setColor(v);
                                setIsDataChanged(true);
                                if (touched.color) {
                                  setErrors((prev) => ({
                                    ...prev,
                                    color: v.trim() === "" ? "Color is required" : "",
                                  }));
                                }
                              }}
                              onBlur={() => {
                                setTouched((prev) => ({ ...prev, color: true }));
                                setErrors((prev) => ({
                                  ...prev,
                                  color: color.trim() === "" ? "Color is required" : "",
                                }));
                              }}
                            />
                            {(touched.color && errors.color) && (
                              <div className="invalid-feedback d-block">
                                {errors.color}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-12 mb-3">
                        <div className="row">
                          <div className="col-md-3 mb-3">
                            <label
                              className="form-label"
                              htmlFor="basic-default-mrp"
                            >
                              MRP <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              id="basic-default-mrp"
                              className={`form-control phone-mask ${(touched.mrp && errors.mrp) ? 'is-invalid' : touched.mrp && !errors.mrp && mrp ? 'is-valid' : ''}`}
                              placeholder="Enter MRP"
                              value={mrp}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d.,\s]/g, '');
                                setMrp(value);
                                setIsDataChanged(true);
                                if (touched.mrp) {
                                  const numMrp = parseFloat(value.replace(/[,\s]/g, ''));
                                  if (!value || value.trim() === "") {
                                    setErrors((prev) => ({ ...prev, mrp: "MRP is required" }));
                                  } else if (isNaN(numMrp) || numMrp <= 0) {
                                    setErrors((prev) => ({ ...prev, mrp: "MRP must be a valid number greater than 0" }));
                                  } else {
                                    setErrors((prev) => ({ ...prev, mrp: "" }));
                                  }
                                }
                                // Auto-calculate price based on MRP and Discount
                                const discountValue = brandDiscount ? parseFloat(brandDiscount.replace(/[,\s]/g, '')) : 0;
                                const mrpValue = parseFloat(value.replace(/[,\s]/g, ''));
                                if (!isNaN(mrpValue) && mrpValue > 0) {
                                  const calculatedPrice = mrpValue - discountValue;
                                  setPrice(calculatedPrice > 0 ? calculatedPrice.toString() : "");
                                }
                              }}
                              onBlur={() => {
                                setTouched((prev) => ({ ...prev, mrp: true }));
                                const numMrp = parseFloat(mrp.replace(/[,\s]/g, ''));
                                if (!mrp || mrp.trim() === "") {
                                  setErrors((prev) => ({ ...prev, mrp: "MRP is required" }));
                                } else if (isNaN(numMrp) || numMrp <= 0) {
                                  setErrors((prev) => ({ ...prev, mrp: "MRP must be a valid number greater than 0" }));
                                } else {
                                  setErrors((prev) => ({ ...prev, mrp: "" }));
                                }
                              }}
                            />
                            {(touched.mrp && errors.mrp) && (
                              <div className="invalid-feedback d-block">
                                {errors.mrp}
                              </div>
                            )}
                          </div>

                          <div className="col-md-3 mb-3">
                            <label
                              className="form-label"
                              htmlFor="basic-default-brand-discount"
                            >
                              Discount
                            </label>
                            <input
                              type="text"
                              id="basic-default-brand-discount"
                              className={`form-control phone-mask ${(touched.brandDiscount && errors.brandDiscount) ? 'is-invalid' : ''}`}
                              placeholder="Enter Discount"
                              value={brandDiscount}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d.,\s]/g, '');
                                setBrandDiscount(value);
                                setIsDataChanged(true);
                                if (touched.brandDiscount) {
                                  const numDiscount = parseFloat(value.replace(/[,\s]/g, ''));
                                  if (value && value.trim() !== "" && (isNaN(numDiscount) || numDiscount < 0)) {
                                    setErrors((prev) => ({ ...prev, brandDiscount: "Discount must be a valid number (0 or greater)" }));
                                  } else {
                                    setErrors((prev) => ({ ...prev, brandDiscount: "" }));
                                  }
                                }
                                // Auto-calculate price based on MRP and Discount
                                const mrpValue = mrp ? parseFloat(mrp.replace(/[,\s]/g, '')) : 0;
                                const discountValue = value ? parseFloat(value.replace(/[,\s]/g, '')) : 0;
                                if (!isNaN(mrpValue) && mrpValue > 0) {
                                  const calculatedPrice = mrpValue - discountValue;
                                  setPrice(calculatedPrice > 0 ? calculatedPrice.toString() : "");
                                }
                              }}
                              onBlur={() => {
                                setTouched((prev) => ({ ...prev, brandDiscount: true }));
                                const numDiscount = parseFloat(brandDiscount.replace(/[,\s]/g, ''));
                                if (brandDiscount && brandDiscount.trim() !== "" && (isNaN(numDiscount) || numDiscount < 0)) {
                                  setErrors((prev) => ({ ...prev, brandDiscount: "Discount must be a valid number (0 or greater)" }));
                                } else {
                                  setErrors((prev) => ({ ...prev, brandDiscount: "" }));
                                }
                              }}
                            />
                            {(touched.brandDiscount && errors.brandDiscount) && (
                              <div className="invalid-feedback d-block">
                                {errors.brandDiscount}
                              </div>
                            )}
                          </div>

                          <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-price"
                        >
                          Price <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-price"
                          className={`form-control phone-mask ${(touched.price && errors.price) ? 'is-invalid' : touched.price && !errors.price && price ? 'is-valid' : ''}`}
                          placeholder="Enter Price"
                          value={price}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPrice(value);
                            setIsDataChanged(true);
                            if (touched.price) {
                              const numPrice = parseFloat(value.replace(/[,\s]/g, ''));
                              if (!value || value.trim() === "") {
                                setErrors((prev) => ({ ...prev, price: "Price is required" }));
                              } else if (isNaN(numPrice) || numPrice <= 0) {
                                setErrors((prev) => ({ ...prev, price: "Price must be a valid number greater than 0" }));
                              } else {
                                setErrors((prev) => ({ ...prev, price: "" }));
                              }
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, price: true }));
                            const numPrice = parseFloat(price.replace(/[,\s]/g, ''));
                            if (!price || price.trim() === "") {
                              setErrors((prev) => ({ ...prev, price: "Price is required" }));
                            } else if (isNaN(numPrice) || numPrice <= 0) {
                              setErrors((prev) => ({ ...prev, price: "Price must be a valid number greater than 0" }));
                            } else {
                              setErrors((prev) => ({ ...prev, price: "" }));
                            }
                          }}
                        />
                        {(touched.price && errors.price) && (
                          <div className="invalid-feedback d-block">
                            {errors.price}
                          </div>
                        )}
                      </div>

                          <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                              htmlFor="basic-default-accessories"
                        >
                          Accessories
                        </label>
                            <input
                              type="text"
                              id="basic-default-accessories"
                          className="form-control"
                              placeholder="Enter Accessories"
                          value={accessories}
                          onChange={(e) => setAccessories(e.target.value)}
                        />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="col-12 d-flex justify-content-end">
                          {editIndex !== null && (
                            <button
                              type="button"
                              className="btn btn-secondary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                              onClick={handleCancelEdit}
                            >
                              Cancel
                            </button>
                          )}
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={addBrandDetails}
                          >
                            {editIndex !== null ? "Update" : "Add"}
                          </button>
                        </div>
                        {tableData.length > 0 ? (
                          <div className="card mt-3">
                            <h5 className="card-header">Brand List</h5>

                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>IMEI</th>
                                    <th>MRP</th>
                                    <th>Discount</th>
                                    <th>Price</th>
                                    <th>Accessories</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(tableData) &&
                                    tableData.map((row, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.model_name}</td>
                                        <td>{row.imei}</td>
                                        <td>{row.mrp || "-"}</td>
                                        <td>{row.discount || "-"}</td>
                                        <td>{row.price}</td>
                                        <td>{row.accessories}</td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm me-1"
                                            onClick={() => handleEdit(index)}
                                            title="Edit"
                                          >
                                            <FaEdit />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDelete(row.id, index)}
                                            title="Delete"
                                          >
                                            <FaTrashAlt />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          <div className=""></div>
                        )}
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Buy Back Details</h5>

                      <div className="col-md-6 mb-3">
                        <div className="row">
                          <div className="col-md-8 mb-3">
                            <label className="form-label" htmlFor="basic-default-buyback-model">
                              Model Name <span className="text-danger">*</span>
                            </label>
                            <div className="row">
                              <div className="col-md-12">
                                <input
                                  type="text"
                                  className={`form-control ${(touched.buyBackModel1 && errors.buyBackModel1) ? 'is-invalid' : touched.buyBackModel1 && !errors.buyBackModel1 && buyBackModel1 ? 'is-valid' : ''}`}
                                  list="browsers"
                                  name="browser"
                                  id="basic-default-buyback-model"
                                  placeholder="Enter Model Name"
                                  value={buyBackModel1}
                                  onChange={(e) => {
                                    handleModelChange(e);
                                    setIsDataChanged(true);
                                    if (touched.buyBackModel1) {
                                      setErrors((prev) => ({
                                        ...prev,
                                        buyBackModel1: e.target.value.trim() === "" ? "Model name is required" : "",
                                      }));
                                    }
                                  }}
                                  onBlur={() => {
                                    setTouched((prev) => ({ ...prev, buyBackModel1: true }));
                                    setErrors((prev) => ({
                                      ...prev,
                                      buyBackModel1: buyBackModel1.trim() === "" ? "Model name is required" : "",
                                    }));
                                  }}
                                />
                                <datalist id="browsers">
                                  {modelList.map((model, index) => (
                                    <option key={index} value={model.model_name} />
                                  ))}
                                </datalist>
                                {(touched.buyBackModel1 && errors.buyBackModel1) && (
                                  <div className="invalid-feedback d-block">
                                    {errors.buyBackModel1}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4 mb-3">
                            <label className="form-label" htmlFor="basic-default-buyback-color">
                              Color <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${(touched.buyBackColor && errors.buyBackColor) ? 'is-invalid' : touched.buyBackColor && !errors.buyBackColor && buyBackColor ? 'is-valid' : ''}`}
                              id="basic-default-buyback-color"
                              list="rainbow-colors"
                              placeholder="Enter Color"
                              value={buyBackColor}
                              onChange={(e) => {
                                const v = capitalizeWords(e.target.value);
                                setBuyBackColor(v);
                                setIsDataChanged(true);
                                if (touched.buyBackColor) {
                                  setErrors((prev) => ({
                                    ...prev,
                                    buyBackColor: v.trim() === "" ? "Color is required" : "",
                                  }));
                                }
                              }}
                              onBlur={() => {
                                setTouched((prev) => ({ ...prev, buyBackColor: true }));
                                setErrors((prev) => ({
                                  ...prev,
                                  buyBackColor: buyBackColor.trim() === "" ? "Color is required" : "",
                                }));
                              }}
                            />
                            <datalist id="rainbow-colors">
                              <option value="Black" />
                              <option value="White" />
                              <option value="Blue" />
                              <option value="Yellow" />
                              <option value="Coral" />
                              <option value="RED" />
                              <option value="Purple" />
                              <option value="Green" />
                              <option value="Starlight" />
                              <option value="Midnight" />
                              <option value="Pink" />
                              <option value="Teal" />
                              <option value="Ultramarine" />
                              <option value="Mist Blue" />
                              <option value="Sage" />
                              <option value="Lavender" />
                              <option value="Silver" />
                              <option value="Space Gray" />
                              <option value="Gold" />
                              <option value="Midnight Green" />
                              <option value="Graphite" />
                              <option value="Pacific Blue" />
                              <option value="Sierra Blue" />
                              <option value="Alpine Green" />
                              <option value="Space Black" />
                              <option value="Deep Purple" />
                              <option value="Black Titanium" />
                              <option value="White Titanium" />
                              <option value="Blue Titanium" />
                              <option value="Natural Titanium" />
                              <option value="Desert Titanium" />
                              <option value="Cosmic Orange" />
                              <option value="Deep Blue" />
                            </datalist>
                            {(touched.buyBackColor && errors.buyBackColor) && (
                              <div className="invalid-feedback d-block">
                                {errors.buyBackColor}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-buyback-imei"
                        >
                          IMEI <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-buyback-imei"
                          className={`form-control phone-mask ${(touched.buyBackIemi && errors.buyBackIemi) ? 'is-invalid' : touched.buyBackIemi && !errors.buyBackIemi && buyBackIemi ? 'is-valid' : ''}`}
                          placeholder="Enter IMEI"
                          value={buyBackIemi}
                          style={{ textTransform: 'uppercase' }}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setBuyBacIemi(value);
                            setIsDataChanged(true);
                            if (touched.buyBackIemi) {
                              setErrors((prev) => ({
                                ...prev,
                                buyBackIemi: value.trim() === "" ? "IMEI is required" : "",
                              }));
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, buyBackIemi: true }));
                            setErrors((prev) => ({
                              ...prev,
                              buyBackIemi: buyBackIemi.trim() === "" ? "IMEI is required" : "",
                            }));
                          }}
                        />
                        {(touched.buyBackIemi && errors.buyBackIemi) && (
                          <div className="invalid-feedback d-block">
                            {errors.buyBackIemi}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-buyback-price"
                        >
                          Price <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-buyback-price"
                          className={`form-control phone-mask ${(touched.buyBackPrice && errors.buyBackPrice) ? 'is-invalid' : touched.buyBackPrice && !errors.buyBackPrice && buyBackPrice ? 'is-valid' : ''}`}
                          placeholder="Enter Price"
                          value={buyBackPrice}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setBuyBackPrice(value);
                            setIsDataChanged(true);
                            if (touched.buyBackPrice) {
                              const numPrice = parseFloat(value.replace(/[,\s]/g, ''));
                              if (!value || value.trim() === "") {
                                setErrors((prev) => ({ ...prev, buyBackPrice: "Price is required" }));
                              } else if (isNaN(numPrice) || numPrice <= 0) {
                                setErrors((prev) => ({ ...prev, buyBackPrice: "Price must be a valid number greater than 0" }));
                              } else {
                                setErrors((prev) => ({ ...prev, buyBackPrice: "" }));
                              }
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, buyBackPrice: true }));
                            const numPrice = parseFloat(buyBackPrice.replace(/[,\s]/g, ''));
                            if (!buyBackPrice || buyBackPrice.trim() === "") {
                              setErrors((prev) => ({ ...prev, buyBackPrice: "Price is required" }));
                            } else if (isNaN(numPrice) || numPrice <= 0) {
                              setErrors((prev) => ({ ...prev, buyBackPrice: "Price must be a valid number greater than 0" }));
                            } else {
                              setErrors((prev) => ({ ...prev, buyBackPrice: "" }));
                            }
                          }}
                        />
                        {(touched.buyBackPrice && errors.buyBackPrice) && (
                          <div className="invalid-feedback d-block">
                            {errors.buyBackPrice}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-buyback-sale-price"
                        >
                          Sale Price
                        </label>
                        <input
                          type="text"
                          id="basic-default-buyback-sale-price"
                          className={`form-control phone-mask ${(touched.buyBackSalePrice && errors.buyBackSalePrice) ? 'is-invalid' : touched.buyBackSalePrice && !errors.buyBackSalePrice && buyBackSalePrice ? 'is-valid' : ''}`}
                          placeholder="Enter Sale Price"
                          value={buyBackSalePrice}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setBuyBackSalePrice(value);
                            setIsDataChanged(true);
                            if (touched.buyBackSalePrice) {
                              const numSalePrice = parseFloat(value.replace(/[,\s]/g, ''));
                              if (value && value.trim() !== "" && (isNaN(numSalePrice) || numSalePrice < 0)) {
                                setErrors((prev) => ({ ...prev, buyBackSalePrice: "Sale Price must be a valid number (0 or greater)" }));
                              } else {
                                setErrors((prev) => ({ ...prev, buyBackSalePrice: "" }));
                              }
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, buyBackSalePrice: true }));
                            const numSalePrice = parseFloat(buyBackSalePrice.replace(/[,\s]/g, ''));
                            if (buyBackSalePrice && buyBackSalePrice.trim() !== "" && (isNaN(numSalePrice) || numSalePrice < 0)) {
                              setErrors((prev) => ({ ...prev, buyBackSalePrice: "Sale Price must be a valid number (0 or greater)" }));
                            } else {
                              setErrors((prev) => ({ ...prev, buyBackSalePrice: "" }));
                            }
                          }}
                        />
                        {(touched.buyBackSalePrice && errors.buyBackSalePrice) && (
                          <div className="invalid-feedback d-block">
                            {errors.buyBackSalePrice}
                          </div>
                        )}
                      </div>
                      <div className="col-12 mb-3 mt-4 d-flex justify-content-end">
                        {editBuyBackIndex !== null && (
                          <button
                            type="button"
                            className="btn btn-secondary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={handleCancelEditBuyBack}
                          >
                            Cancel
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ marginLeft: "5px", marginRight: "5px" }}
                          onClick={addBuyBackDetails}
                        >
                          {editBuyBackIndex !== null ? "Update" : "Buy Back"}
                        </button>
                      </div>
                      {buyBackItems.length > 0 && (
                        <div className="col-12 mt-3">
                          <div className="card">
                            <h5 className="card-header">Buy Back List</h5>
                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>IMEI</th>
                                    <th>Color</th>
                                    <th>Price</th>
                                    <th>Sale Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(buyBackItems) &&
                                    buyBackItems.map((row, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.model_name}</td>
                                        <td>{row.imei}</td>
                                        <td>{row.color}</td>
                                        <td>{row.price}</td>
                                        <td>{row.sales_price || "-"}</td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm me-1"
                                            onClick={() => handleEditBuyBack(index)}
                                            title="Edit"
                                          >
                                            <FaEdit />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDeleteBuyBack(index)}
                                            title="Delete"
                                          >
                                            <FaTrashAlt />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Payment Details</h5>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Sub Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Sub Total (MRP Sum)"
                          value={subTotal}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Grant Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Grant Total (Price Sum)"
                          value={grantTotal}
                          readOnly
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-cash-amount"
                        >
                          Cash Amount <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                          type="text"
                          id="basic-default-cash-amount"
                          className={`form-control phone-mask ${(touched.payableAmount && errors.payableAmount) || (submitAttempted && errors.payableAmount) ? 'is-invalid' : ''}`}
                          placeholder="Enter Cash Amount"
                          value={payableAmount}
                          disabled={grantTotal < 0}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPayableAmount(value);
                            setIsDataChanged(true);
                            if (touched.payableAmount || submitAttempted) {
                              const paymentErrors = validatePayment();
                              setErrors((prev) => ({ ...prev, ...paymentErrors }));
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, payableAmount: true }));
                            const paymentErrors = validatePayment();
                            setErrors((prev) => ({ ...prev, ...paymentErrors }));
                          }}
                        />
                        {((touched.payableAmount && errors.payableAmount) || (submitAttempted && errors.payableAmount)) && (
                          <div className="invalid-feedback d-block">
                            {errors.payableAmount}
                          </div>
                        )}
                        {grantTotal < 0 && (
                          <small className="text-muted d-block">
                            Payment fields are disabled when Grant Total is negative
                          </small>
                        )}
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-payment-mode"
                        >
                          Payment Mode
                        </label>
                        <input
                          id="basic-default-payment-mode"
                          className="form-control"
                          placeholder="Cash Deposit"
                          rows={1}
                          value={paymentMode}
                          onChange={(e) => setPaymentMode(e.target.value)}
                          readOnly
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-online-amount"
                        >
                          Online Amount <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                          type="text"
                          id="basic-default-online-amount"
                          className={`form-control phone-mask ${(touched.payableAmount1 && errors.payableAmount1) || (submitAttempted && errors.payableAmount1) ? 'is-invalid' : ''}`}
                          placeholder="Enter Online Amount"
                          value={payableAmount1}
                          disabled={grantTotal < 0}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPayableAmount1(value);
                            setIsDataChanged(true);
                            
                            // If Online Amount is cleared, also clear paymentMode1 error
                            if (!value || value.trim() === "") {
                              setErrors((prev) => ({ ...prev, paymentMode1: "", payableAmount1: "" }));
                            } else if (touched.payableAmount1 || submitAttempted) {
                              // Validate after state update
                              setTimeout(() => {
                              const paymentErrors = validatePayment();
                              setErrors((prev) => ({ ...prev, ...paymentErrors }));
                              }, 0);
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, payableAmount1: true }));
                            // Validate after state update
                            setTimeout(() => {
                            const paymentErrors = validatePayment();
                            setErrors((prev) => ({ ...prev, ...paymentErrors }));
                            }, 0);
                          }}
                        />
                        {((touched.payableAmount1 && errors.payableAmount1) || (submitAttempted && errors.payableAmount1)) && (
                          <div className="invalid-feedback d-block">
                            {errors.payableAmount1}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-payment-mode-2"
                        >
                          Payment Mode <small className="text-muted">(Required if Online Amount entered)</small>
                        </label>
                        <select
                          className={`form-select ${(touched.paymentMode1 && errors.paymentMode1) || (submitAttempted && errors.paymentMode1) ? 'is-invalid' : ''}`}
                          id="basic-default-payment-mode-2"
                          value={paymentMode1}
                          disabled={grantTotal < 0}
                          onChange={(e) => {
                            const newPaymentMode1 = e.target.value;
                            setPaymentMode1(newPaymentMode1);
                            setIsDataChanged(true);
                            
                            // Immediately clear paymentMode1 error when a value is selected
                            // This prevents false validation errors due to async state updates
                            if (newPaymentMode1 && newPaymentMode1.trim() !== "") {
                              setErrors((prev) => ({ ...prev, paymentMode1: "" }));
                            }
                            // If value is cleared and field is touched, validate
                            else if (touched.paymentMode1 || submitAttempted) {
                              if (payableAmount1 && payableAmount1.trim() !== "") {
                                setErrors((prev) => ({ 
                                  ...prev, 
                                  paymentMode1: "Payment mode is required when online amount is entered" 
                                }));
                              }
                            }
                          }}
                          onBlur={() => {
                            setTouched((prev) => ({ ...prev, paymentMode1: true }));
                            const paymentErrors = validatePayment();
                            setErrors((prev) => ({ ...prev, ...paymentErrors }));
                          }}
                        >
                          <option value="" disabled>
                            Select Payment Mode
                          </option>
                          <option value="Net Banking">Net Banking</option>
                          <option value="Paytm">Paytm</option>
                          <option value="Phone Pay">Phone Pay</option>
                          <option value="Google Pay">Google Pay</option>
                        </select>
                        {((touched.paymentMode1 && errors.paymentMode1) || (submitAttempted && errors.paymentMode1)) && (
                          <div className="invalid-feedback d-block">
                            {errors.paymentMode1}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Balance Amount
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="
                                "
                          value={balance = Number(grantTotal) - Number(payableAmount) - Number(payableAmount1)}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setBalance(value);
                            setIsDataChanged(true);
                          }}

                        />
                      </div>

                      {submitAttempted && errors.tableData && (
                        <div className="col-12 mb-3">
                          <div className="alert alert-danger" role="alert">
                            {errors.tableData}
                          </div>
                        </div>
                      )}
                      <div className="col-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ marginLeft: "5px", marginRight: "5px" }}
                          onClick={addAllDetails}
                        >
                          Submit
                        </button>

                        <button type="button" className="btn btn-danger" onClick={cancelModel}>
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
